import { OverdoorMatetialCreationStrategies } from "@/app/domain/strategies";

import { SheetMaterialCode } from "../constants";

import {
    GlassPartition,
    GlassThinknessPartition,
    OverdoorMaterial,
    Partition,
} from "../domain";
import { OverdoorHardware } from "../domain/entities/hardware";
import { TransomHardwareStrategyRegistry } from "./transom-hardwares-strategies.service";
import { DoorType } from "../@types/shared";
import { getKompasMultiplier } from "@/app/predicates/systems.predicates";
import { DimensionValue } from "@/app/domain/entities/dimensions";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { computed } from "vue";


export class OverdoorService {
    static createOverdoorMaterial(
        overdoorMaterialType: string,
        activePartition: Partition,
    ): OverdoorMaterial[] {
        if (overdoorMaterialType === SheetMaterialCode) {
            const strategies = {
                [SheetMaterialCode]:
                    OverdoorMatetialCreationStrategies.OverdoorAluminiumMaterialStrategy,
            };

            const Strategy = new strategies[overdoorMaterialType]();
            return Strategy.create() as unknown as OverdoorMaterial[];
        }

        return this.createOverdoorGlassMaterial(activePartition);
    }

    static createOverdoorGlassMaterial(
        activePartition: Partition,
    ): OverdoorMaterial[] {
        const estimateStore = useNewEstimateStore();
        const installationSystem = computed(() => estimateStore.estimate.installedSystemCode);

        const multiplier = getKompasMultiplier(installationSystem.value as string);

        const glass = activePartition.getActiveGlass();
        const glassThickness = activePartition.getActiveGlassThinkness();


        const overdoorGlass = new GlassPartition({
            structureType: glass!.structureType,
        });
        overdoorGlass.dimensions.area = new DimensionValue(overdoorGlass.dimensions.area.getValue() * multiplier);

        const overdoorGlassThickness = new GlassThinknessPartition({
            structureType: glassThickness!.structureType,
        });

        return [overdoorGlass, overdoorGlassThickness] as OverdoorMaterial[];
    }

    static createTransomHardwares(doorType: string): OverdoorHardware[] {
        const doorsHardwaresRegistry = new TransomHardwareStrategyRegistry();

        const Strategy = doorsHardwaresRegistry.getStrategy(
            doorType as DoorType,
        );

        if (!Strategy) {
            return [];
        }

        const strategy = new Strategy();
        return strategy.create() as unknown as OverdoorHardware[];
    }
}
